import { render, staticRenderFns } from "./SearchAPI.vue?vue&type=template&id=1e157497"
import script from "./SearchAPI.vue?vue&type=script&lang=js"
export * from "./SearchAPI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports